// Auto-generated file - do not edit manually
// Generated at build time with git information

export const BUILD_INFO = {
  "gitCommitHash": "2a6827374141dce90a3bbef35a3ea8ed49fd4f2f",
  "gitCommitShortHash": "2a68273",
  "gitBranch": "main",
  "buildNumber": "368",
  "buildTimestamp": "2026-05-04T18:43:39.224Z"
};
